import { getSystemType, SystemType } from '@nibfe/mkt-env-api';
import { isDianpingAppOrWebview } from '@nibfe/mkt-env-api';
export const getUTMParams = (queryParams) => {
    const systemType = getSystemType();
    const isAndroid = systemType === SystemType.android;
    const isIOS = systemType === SystemType.ios;
    const isInHarmony = systemType === SystemType.harmony;
    return {
        utmMedium: queryParams.utm_medium || (isIOS ? 'iphone' : isAndroid ? 'android' : isInHarmony ? 'HarmonyOS' : 'iphone'),
        utmCampaign: queryParams.utm_campaign || (isDianpingAppOrWebview() ? 'Adianping-novaBdianping-novaD0H0' : 'Meituan'),
        // 决定筛选POI的城市体系
        utmContent: queryParams.utm_content || queryParams.uuid,
        utmTerm: queryParams.utm_term || '1200420200',
        utmSource: queryParams.utm_source || 'meituaninternaltest',
        version_name: queryParams?.version_name || "12.42.200"
    };
};
